import React, { useState } from 'react';
import s from './button.module.scss';
import cx from 'clsx';
import Icon from '../Icon/Icon';

const TModifiers = ['inverted', 'light-blue', 'inline', 'dotted', 'transparent'];
type TModifier = (typeof TModifiers)[number];

interface ButtonProps {
    isLoading?: boolean;
    icon?: string;
    disabled?: boolean;
    onClick?: () => void;
    label: string;
    className?: string;
    modifier?: TModifier | TModifier[];
}

const Button = ({ className, label, onClick, modifier, isLoading, icon, disabled }: ButtonProps) => {
    const isClickable = !isLoading && !disabled;
    const [isClicked, toggleClick] = useState(false);

    const parseModifiers = () => {
        return Array.isArray(modifier) ? modifier.map((item) => s[`item--${item}`]) : s[`item--${modifier}`];
    };

    const style = cx(
        s.item,
        modifier ? parseModifiers() : s['item--regular'],
        isLoading && s['item--loading'],
        isClicked && s['item--clicked'],
        disabled && s['item--disabled'],
        className,
    );

    const handleClick = () => {
        if (isClickable && onClick) {
            onClick();
        }
    };

    const shouldButtonToggle = (bool: boolean) => {
        if (isClickable) toggleClick(bool);
    };

    return (
        <button
            className={style}
            onMouseDown={() => shouldButtonToggle(true)}
            onMouseUp={() => toggleClick(false)}
            onMouseLeave={() => toggleClick(false)}
            onClick={handleClick}
        >
            {icon && <Icon icon={icon} />}
            <span>{label}</span>
        </button>
    );
};

export default Button;
